

































































































import {Component, Vue} from 'vue-property-decorator';
import {CustomerDto} from '@/dto/CustomerDto';
import {Customer} from '@/entity/Customer';
import XHeader from "@/views/KeShangAdmin/XHeader.vue";

@Component({
  components: {XHeader},
})
export default class KeShangChaXun extends Vue {
  isDetailOpen = false;


  get id() {
    return this.$route.params.id as string;
  }

  private customer: Customer = new Customer;

  async getCustomer() {
    this.customer = await CustomerDto.findById(Number(this.id));
  }



  private mounted() {
    this.getCustomer();
    return;
  }
}
